module.exports = __webpack_public_path__ + "img/dark-arrow-right.ce5083b9.svg";